import userType from '../type/personType';
import quoteGQLString from '../util/quoteGQLString';

// Select the user by email (the pharmacy-user business key) — never by the
// Firestore document id, which the API rejects.
export default (email) => `
    userById (email: ${quoteGQLString(email)}) {
        ${userType()}
    }
`;
